import { render } from "./DocumentAnalysisBadge.vue?vue&type=template&id=db3cf716"
import script from "./DocumentAnalysisBadge.vue?vue&type=script&lang=js"
export * from "./DocumentAnalysisBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__